import React, { useContext, useState } from "react";
import Navbar from "../components/Navbar";
import { useNavigate, Link } from "react-router-dom";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { lang, phone, setPhone } = useContext(languageContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit number");
      return;
    }

    const headerList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    try {
      setLoader(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/warden_send_otp",
        JSON.stringify({ phone }),
        { headers: headerList }
      );
      navigate("/otp", { state: { from: "warden-login" } });
    } catch (error) {
      console.error("Error sending OTP:", error.response?.data || error.message);
      setResponseMessage(
        error.response?.data?.msg || data[lang]["auth"][7]
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-blue-50 via-white to-indigo-100">
      <Navbar />
      <div className="w-full flex flex-col items-center justify-center pt-20 px-4">
        <div className="mb-6 text-center">
          <h1 className="text-4xl font-extrabold text-indigo-900">
            {data[lang]["auth"][4] || "Warden Login"}
          </h1>
          <p className="text-base font-normal text-gray-600 mt-2">
            {data[lang]["auth"][8] || "Access your institutional dashboard securely."}
          </p>
        </div>

        <div className="bg-white shadow-2xl rounded-3xl px-10 py-8 w-full sm:w-[90%] md:w-[60%] lg:w-[30%] transition-all">
          <form onSubmit={handleLogin} className="space-y-6">
            <div className="text-left">
              <label className="block text-base font-semibold text-gray-800 mb-2">
                {data[lang]["auth"][9] || "Mobile Number"}
              </label>
              <input
                type="text"
                required
                maxLength="10"
                className="w-full px-5 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:border-indigo-500 focus:ring focus:ring-indigo-200 transition text-sm"
                placeholder={data[lang]["auth"][10] || "Enter your 10-digit phone number"}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-xl font-semibold transition text-base shadow-lg"
            >
              {loader ? (
                <div className="animate-spin h-5 w-5 border-t-2 border-white border-solid mx-auto"></div>
              ) : (
                <span>{data[lang]["auth"][11] || "Send OTP"}</span>
              )}
            </button>
            {responseMessage && (
              <div className="text-red-500 mt-3 text-sm text-center font-medium">
                {responseMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;